import { render, staticRenderFns } from "./Purchase.vue?vue&type=template&id=6000cbe4"
import script from "./Purchase.vue?vue&type=script&lang=ts"
export * from "./Purchase.vue?vue&type=script&lang=ts"
import style0 from "./Purchase.vue?vue&type=style&index=0&id=6000cbe4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports